// extracted by mini-css-extract-plugin
export var lecture = "lecture-item-module--lecture--QGSs4";
export var info = "lecture-item-module--info--7Gw4p";
export var period = "lecture-item-module--period--8F1FL";
export var title = "lecture-item-module--title--qSnIr";
export var description = "lecture-item-module--description--adlsz";